import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

import api from '../../services/ApiManagement/Index';
import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';
import { useOnlineStatus } from '../../hooks/onlineStatus';
import { useSync } from '../../hooks/sync';

import {
  IconSun,
  IconMoon,
  IconCirclePlus,
  IconCloud,
  IconRefresh,
  IconBell,
} from '@tabler/icons';

import Header from '../../components/Header';
import BottomNav from '../../components/BottomNav';
import PropertyItem from '../../components/PropertyItem';
import Button from '../../components/Button';
import { Label, Skeleton } from '../../components/Generic';
import { Container, Content, UserContainer, SyncBar } from './styles';

import userImg from '../../assets/images/user-avatar.png';
const Home: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [properties, setProperties] = useState<any>({});
  const [greeting, setGreeting] = useState('');

  const { user, signOut } = useAuth();
  const { addToast } = useToast();
  const isOnline = useOnlineStatus();
  const { status, syncLocal, syncRemote } = useSync();
  const history = useHistory();

  useEffect(() => {
    getUserProperties();

    const hour = new Date().getHours();
    const greeting =
      (hour < 12 && 'Bom dia') || (hour < 18 && 'Boa tarde') || 'Boa noite';

    setGreeting(greeting);
  }, []);

  const getUserProperties = async () => {
    setLoading(true);

    try {
      const response = await api.minhasPropriedades(
        '/propriedades/minhas',
        isOnline,
        user,
        {},
      );

      setProperties(response.data);

      syncLocal();
      syncRemote();
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Header />

      <Content>
        <UserContainer>
          <div>
            <img src={user.url || userImg} alt="Foto" />

            <div>
              <span>{greeting},</span>
              <h2>{user.nome.split(' ')[0]}</h2>
            </div>
          </div>

          <button
            className="notifications"
            onClick={() => history.push('/notificacoes')}
          >
            <IconBell size={24} />
          </button>
        </UserContainer>

        <SyncBar onClick={() => history.push('/sincronizacao')}>
          {status === 'syncing' ? (
            <div>
              <IconRefresh size={20} color="#777" />
            </div>
          ) : (
            <IconCloud size={20} color="#777" />
          )}

          {status === 'synced' && <span>Sincronizado</span>}

          {status === 'syncing' && <span>Sincronizando</span>}

          {status === 'error' && <span>Erro na sincronização</span>}

          {status === 'waiting' && <span>Aguardando conexão</span>}

          {/* <IconChevronRight size={20} color="#777" /> */}
        </SyncBar>

        {loading ? (
          <>
            <Skeleton style={{ height: 20, width: 180, marginBottom: 20 }} />
            <Skeleton
              style={{ height: 110, width: '100%', marginBottom: 30 }}
            />
            <Skeleton
              style={{ height: 110, width: '100%', marginBottom: 30 }}
            />
          </>
        ) : (
          <div>
            {properties?.minhasPropriedades?.length > 0 && (
              <Label>Minhas propriedades</Label>
            )}

            {properties?.minhasPropriedades?.map((property: any) => (
              <Link key={property.id} to={`/propriedade/${property.id}`}>
                <PropertyItem
                  location={property.descricao}
                  name={property.nome}
                  isPrivate={property.privada}
                  imageUrl={
                    property.imagens?.length > 0
                      ? property.imagens[0]?.image_url
                      : null
                  }
                />
              </Link>
            ))}

            {properties?.colaboracoes?.length > 0 && (
              <Label>Colaborações</Label>
            )}

            {properties?.colaboracoes?.map((property: any) => (
              <Link key={property.id} to={`/propriedade/${property.id}`}>
                <PropertyItem
                  location={property.descricao}
                  name={property.nome}
                  isPrivate={property.privada}
                  imageUrl={
                    property.imagens?.length > 0
                      ? property.imagens[0]?.image_url
                      : null
                  }
                  ownerImageUrl={property.usuarios?.url}
                  ownerName={property.usuarios?.nome}
                />
              </Link>
            ))}

            <Button onClick={() => history.push('/propriedade/nova')}>
              <IconCirclePlus size={25} />
              Nova propriedade
            </Button>
          </div>
        )}
      </Content>

      <BottomNav selected="home" />
    </Container>
  );
};

export default Home;
